'use client';

import { createAuthClient } from 'better-auth/react';

// No baseURL — the client and the /api/auth/* route live in the same
// Next.js app, so same-origin resolution is correct.
export const authClient = createAuthClient();
